import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import PhoneSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/phone.svg';
import LocationLineSvg from 'pubweb-smokey/dist/images/svg/iconography-16x16/location-line.svg';
import { RetailerCardStyles } from './RetailerCard.styled';
import {
  formatDealerName,
  formatPhoneNumberFromNumber,
  formatStringToDisplayCase,
} from 'pubweb-smokey/dist/utils/formatters';

const RetailerCard = ({ store }) => {
  return (
    <RetailerCardStyles>
      {store && store.name && (
        <Link
          href={`/locations/${store.navigationSlug}/`}
          className="store-name-link"
        >
          <h5 className="store-name">{formatDealerName(store.name)}</h5>
        </Link>
      )}
      {store && store.phoneNumber && (
        <>
          {/* they only want a link on the phone number on mobile
                taking care of this with css, hence the desktop/mobile classnames */}
          <div className="store-info standard store-info-phone desktop">
            <span>
              <PhoneSvg viewBox="0 0 16 16" />
            </span>

            {formatPhoneNumberFromNumber(store.phoneNumber)}
          </div>
          <div className="store-info standard store-info-phone mobile">
            <span>
              <PhoneSvg viewBox="0 0 16 16" />
            </span>

            <a href="tel:1-562-867-5309">
              {formatPhoneNumberFromNumber(store.phoneNumber)}
            </a>
          </div>
        </>
      )}
      {store && (
        <div className="store-info store-address standard">
          <span>
            <LocationLineSvg viewBox="0 0 16 16" />
          </span>

          <p className="store-address-text">
            {store.address1 && formatStringToDisplayCase(store.address1)}
            {store.address1 && <br />}
            {store.address2 && formatStringToDisplayCase(store.address2)}
            {store.address2 && <br />}
            {formatStringToDisplayCase(store.city)}, {store.stateProvince}{' '}
            {store.postalCode}
          </p>
        </div>
      )}
      {store && store.navigationSlug && (
        <Link
          href={`/locations/${store.navigationSlug}/`}
          className="view-homes-link"
        >
          View Homes
        </Link>
      )}
    </RetailerCardStyles>
  );
};

RetailerCard.propTypes = {
  store: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.any,
    name: PropTypes.any,
    navigationSlug: PropTypes.any,
    phoneNumber: PropTypes.any,
    postalCode: PropTypes.any,
    stateProvince: PropTypes.any,
  }),
};

export default RetailerCard;
